<template>
    <div class="slider-container">
        <div
            v-if="activities.length > 1"
            ref="slider__controls"
            class="slider__controls"
            aria-label="Map activities slider"
            tabindex="0"
        >
            <a
                class="prev"
                aria-controls="customize"
                data-controls="prev"
                tabindex="-1"
                ><i
                    class="fa fa-chevron-left color--purple-1"
                    aria-hidden="true"
                ></i
            ></a>
            <a
                class="next"
                aria-controls="customize"
                data-controls="next"
                tabindex="-1"
                ><i
                    class="fa fa-chevron-right color--purple-1"
                    aria-hidden="true"
                ></i
            ></a>
        </div>
        <div ref="slider" class="activities-map__slider row">
            <activity-card
                v-for="activity in activities"
                :key="activity.id"
                :activity="activity"
            ></activity-card>
        </div>
    </div>
</template>

<script>
import { tns } from 'tiny-slider/src/tiny-slider';
import activityCard from '@/components/cards/activity-card';

export default {
    components: {
        activityCard
    },
    props: {
        activities: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            slider: ''
        };
    },

    methods: {
        initSlider() {
            this.slider = tns({
                container: this.$refs.slider,
                items: 1,
                controlsContainer: this.$refs.slider__controls,
                slideBy: 1,
                mouseDrag: false,
                swipeAngle: false,
                lazyload: false,
                nav: false,
                autoplayButton: false,
                autoplayButtonOutput: false,
                preventScrollOnTouch: 'auto',
                speed: 400
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.slider-container {
    width: 355px;
    padding: 0 50px 0 50px;
    overflow: hidden;
}

// .activities-map__slider {
//     @include media-breakpoint-up(md) {
//         margin: 0 -15px;
//     }
// }

.card {
    left: 15px;
    font-size: 1rem;
}

.tns-ovh {
    margin: 0;

    @include media-breakpoint-up(lg) {
        margin: 0 -30px;
    }
}

.slider__controls {
    position: absolute;
    height: 100%;
    width: 100%;
    display: block;
    left: 0;
}

.prev {
    position: absolute;
    left: 0;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        font-size: 30px;
    }
}

.next {
    position: absolute;
    right: 0;
    font-size: 24px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 20;
    cursor: pointer;

    @include media-breakpoint-up(md) {
        font-size: 30px;
    }
}
</style>
